import { FC } from "react";
import { parseCurrency } from "src/framework/commons/masks";
import { ChangeValue, CustomTextField } from "../InputParameters";
import { InputText, InputTextParameters } from "../InputText";


type CurrencyTypes = "BRL" | "USD" | "EUR"

interface InputCurrencyProperties extends InputTextParameters, CustomTextField {
    currency?: CurrencyTypes;
    numberValue?: boolean;
    sufixSymbol?: boolean;
}

const InputCurrency: FC<InputCurrencyProperties> = ({
    currency = "BRL",
    numberValue = false,
    fullWidth = true,
    sufixSymbol = false,
    onChangeValue,
    ...props
}) => {

    const currencySymbol = () => {

        if (currency === "USD") {
            return "$"
        }

        if (currency === "EUR") {
            return "€"
        }

        return "R$"
    }

    if (sufixSymbol) {
        props.sufix = <>{currencySymbol()}</>
    } else {
        props.prefix = <>{currencySymbol()}</>
    }

    return (
        <InputText
            {...props}
            fullWidth={fullWidth}
            mask={"currency"}

            maxLength={15}
            InputLabelProps={{ shrink: true }}

            onChange={(e: any) => {
                if (props.onChange) {
                    props?.onChange(e)
                }

                if (onChangeValue) {
                    const val = e.target.value ? parseCurrency(e.target.value) : "";
                    const returnValue: ChangeValue = {
                        value: val,
                        numberValue: Number(val.replace(/\./g, "").replace(/\,/, ".")),
                        name: props?.name ? props.name : null
                    }

                    onChangeValue(returnValue)
                }
            }}
        />
    );
}

export { InputCurrency }